<template>
    <div class="lww-gap" :class="`h-${height}`"></div>
</template>
<script>
export default {
    props:{
       height:{
           type:Number,
           default: 8
       } 
    }
}
</script>
<style lang="less" scoped>
.lww-gap{
    background-color: #f5f7fa;
}
</style>